import * as React from 'react';
import {Props} from './model';
import {PollsTypeView} from '../components/typeView';
import Screen from '../../../shared/components/screen';
import {BreadcrumbItem} from '../../../shared/components/breadcrumbs/model';
import {Routes, Screens} from '../../../shared/routing';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {DeviceSize} from '../../../shared/theme/helpers';
import {useStyles} from '../../../shared/hooks/styles';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {images} from '../../../assets/icons';
import {View} from 'react-native';
import {Container} from '../../../shared/components/container';

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: 'Опросы и голосования',
    routeName: Screens.Polls,
    webRoute: Routes.polls,
  },
  {
    title: 'Опросы',
    routeName: Screens.PollsTypeSurvey,
    webRoute: Routes.pollsTypeSurvey,
  },
];

export default ({content, pollGroups, isLoading}: Props) => {
  const isDesktop = useIsDesktop();
  const styles = useStyles(({mediaOnly}) => ({
    sectionContainer: {
      position: 'relative',
      zIndex: 1,
    },
    bg: {
      position: 'absolute',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          width: 1003,
          height: 1004,
          top: -224,
          right: -350,
        },
        {
          width: 600,
          height: 600,
          top: 100,
          right: -250,
        },
      ),
      zIndex: 0,
    },
  }));

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <Container style={styles.sectionContainer}>
          <PollsTypeView
            title='Опросы'
            breadcrumbs={breadcrumbs}
            description={content.polls.surveyDescription}
            pollGroups={pollGroups}
            isLoading={isLoading}
          />
        </Container>
        {isDesktop && (
          <View style={styles.bg}>
            <images.ShapesPollsBg width={styles.bg.width as number} height={styles.bg.height as number} />
          </View>
        )}
      </CustomScrollView>
    </Screen>
  );
};
